import ApiService from '@/services/ApiService'
import { useUserStore } from '@/stores/UserStore'
import { User } from '@/models/User'

export default class UserService {
  public static async loadInfo(): Promise<void> {
    return ApiService.get<{ token: string, signing_url: string, user: User }>(`users/info`).then((response) => {
      const userStore = useUserStore()
      userStore.user = response.user
    })
  }

  public static async login(email: string): Promise<void> {
    return ApiService.post(`auth/login`, { email })
  }

  public static async logout(): Promise<void> {
    return ApiService.post<void>(`auth/logout`).finally(() => {
      const userStore = useUserStore()
      userStore.logout()
    })
  }

  public static async otpLogin(email: string, otp: string): Promise<void> {
    return ApiService.post<{ token: string, user: User }>(`auth/otp-login`, { email, otp }).then((response) => {
      const userStore = useUserStore()
      userStore.logout()
      userStore.token = response.token
      userStore.user = response.user
      return this.loadInfo()
    })
  }

  public static async register(postData: { email: string, nickname: string }): Promise<void> {
    return ApiService.post('auth/register', postData).then(() => {
      const userStore = useUserStore()
      userStore.logout()
    })
  }
}
